import { render, staticRenderFns } from "./ProductLandingPage.vue?vue&type=template&id=31e8779a&scoped=true&"
import script from "./ProductLandingPage.vue?vue&type=script&lang=js&"
export * from "./ProductLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductLandingPage.vue?vue&type=style&index=0&id=31e8779a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e8779a",
  null
  
)

export default component.exports